import { parse, format } from 'date-fns';
var dateFormat = 'yyyy-MM-dd HH:mm:ss';
var dateFormatNoTime = 'yyyy-MM-dd';
var uiDateFormat = 'dd.MM.yyyy';
var uiTimeFormat = 'HH:mm';
export function stringToDate(dateStr, opts) {
    if (dateStr) {
        return parse(dateStr, (opts === null || opts === void 0 ? void 0 : opts.format) ? opts.format : (opts === null || opts === void 0 ? void 0 : opts.noTime) ? dateFormatNoTime : dateFormat, new Date());
    }
}
export function dateToString(date, opts) {
    if (date) {
        if (opts === null || opts === void 0 ? void 0 : opts.resetTime) {
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);
        }
        return format(date, (opts === null || opts === void 0 ? void 0 : opts.format) ? opts.format : dateFormat);
    }
}
// Converts date object od date string from the api to the UI expected format
export function dateToUiString(date, opts) {
    if (typeof date === 'string') {
        date = stringToDate(date, opts);
    }
    if (date) {
        return dateToString(date, { format: (opts === null || opts === void 0 ? void 0 : opts.format) || uiDateFormat });
    }
    return '';
}
// Converts date object od date string from the api to the UI expected time format
export function timeToUiString(date) {
    if (typeof date === 'string') {
        date = stringToDate(date);
    }
    if (date) {
        return dateToString(date, { format: uiTimeFormat });
    }
    return '';
}
export function parseTime(timeString) {
    if (timeString) {
        var parts = timeString.split(':');
        return [Number(parts[0]), Number(parts[1])];
    }
    return [];
}
/**
 * Compare two time points and return 1, 0 or -1 in case timeA is bigger, equal or smaller then timeB (accordingly)
 * The format of the times should be HH:mm
 *
 * Example:
 *
 * 1. compareTimes('15:30', '12:30') => 1
 * 2. compareTimes('15:30', '15:30') => 0
 * 3. compareTimes('15:30', '16:30') => -1
 *
 */
export function compareTimes(timeA, timeB) {
    if (timeA && timeB) {
        var timeAParts = timeA.split(':');
        var timeBParts = timeB.split(':');
        var timeAHoursStr = timeAParts[0];
        var timeAMinutesStr = timeAParts[1];
        var timeBHoursStr = timeBParts[0];
        var timeBMinutesStr = timeBParts[1];
        if (!timeAHoursStr || !timeAMinutesStr || !timeBHoursStr || !timeBMinutesStr) {
            return 0;
        }
        var timeAHours = Number(timeAHoursStr);
        var timeAMinutes = Number(timeAMinutesStr);
        var timeBHours = Number(timeBHoursStr);
        var timeBMinutes = Number(timeBMinutesStr);
        if (timeAHours < timeBHours) {
            return -1;
        }
        else if (timeAHours > timeBHours) {
            return 1;
        }
        else if (timeAMinutes < timeBMinutes) {
            return -1;
        }
        else if (timeAMinutes > timeBMinutes) {
            return 1;
        }
    }
    return 0;
}
/**
 * Compare two dates (time is excluded)
 *
 * @param {Date} dateA
 * @param {Date} dateB
 */
export function compareDates(dateA, dateB, opts) {
    var newDateA = new Date(dateA);
    var newDateB = new Date(dateB);
    if (!(opts === null || opts === void 0 ? void 0 : opts.includeTimes)) {
        newDateA.setHours(0);
        newDateA.setMinutes(0);
        newDateA.setSeconds(0);
        newDateA.setMilliseconds(0);
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.includeTimes)) {
        newDateB.setHours(0);
        newDateB.setMinutes(0);
        newDateB.setSeconds(0);
        newDateB.setMilliseconds(0);
    }
    return newDateA.getTime() - newDateB.getTime();
}
